import * as actionTypes from "./actionTypes";

export const recruitUnit = (
  unitType: string,
  amount: number,
  govId?: number,
  isOwner?: boolean
) => ({
  type: actionTypes.RECRUIT_UNIT,
  unitType,
  amount,
  govId,
  isOwner
})

export const releaseUnit = (
  unitType: string,
  amount: number,
  govId?: number,
  isOwner?: boolean
) => ({
  type: actionTypes.RELEASE_UNIT,
  unitType,
  amount,
  govId,
  isOwner
})

export const occupyBanner = (position: string, backupOrder: number, govId: number) => ({
  type: actionTypes.OCCUPY_BANNER,
  position,
  backupOrder,
  govId
})

export const leaveBanner = (govId: number) => ({
  type: actionTypes.LEAVE_BANNER,
  govId
})

export const addBannerUnits = (
  govId: number,
  position: string,
  tactics: number,
  target: string,
  unitId: string,
  amount: number
) => ({
  type: actionTypes.ADD_BANNER_UNITS,
  govId,
  position,
  tactics,
  target,
  unitId,
  amount
})

export const removeBannerUnits = (
  govId: number,
  position: string,
  unitId: string,
  amount: number
) => ({
  type: actionTypes.REMOVE_BANNER_UNITS,
  govId,
  position,
  unitId,
  amount
})


export const assignBannerGeneral = (bannerId: number) => ({
  type: actionTypes.ASSIGN_BANNER_GENERAL,
  bannerId
})


export const releaseBannerGeneral = (bannerId: number) => ({
  type: actionTypes.RELEASE_BANNER_GENERAL,
  bannerId
})

export const setBattleTactics = (tacticsId: number) => ({
  type: actionTypes.SET_BATTLE_TACTICS,
  tacticsId
})
